import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import Dialog from "../../components/dialog/dialog";
import { useDispatch, useSelector } from "react-redux";
import { authSet, getOriginUid, getStaffUid, getUid, logout } from "../../redux/authSlice";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components";
import { modeSet } from "../../redux/layoutSlice";
import { branchNameSet } from "../../redux/userSlice";
import { logoutUser } from "../../utils/logout";

export default function LogOut({ open, handleClose }: any) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dealerUid = useSelector(getUid);
  const staffUid = useSelector(getStaffUid);
  const originUid = useSelector(getOriginUid);

  function handleNavigate() {
    navigate("/login");
  }

  const handleLogout = async () => {
    // dealerUid is the branch/dealer, userUid is the actual user (staff or manager)
    const userUid = staffUid || originUid;

    try {
      // Set offline and sign out (offline is set first inside logoutUser)
      await logoutUser(dealerUid, userUid);

      // Clean up local state
      localStorage.removeItem("userPreferences");
      localStorage.removeItem("branchUid");
      localStorage.removeItem("branchName");
      dispatch(branchNameSet(null));
      dispatch(modeSet("light"));
      localStorage.setItem("colorMode", "light");
      dispatch(authSet(undefined));
      dispatch(logout());
      handleClose();
      handleNavigate();
    } catch (error) {
      console.log(error);
    }
  };

  const renderTitle = "Log Out";

  const renderContent = (
    <Box sx={{ width: "100%" }}>
      <Typography variant="body1" fontWeight={400}>
        Are you sure you want to log out?
      </Typography>
    </Box>
  );
  const renderActions = (
    <Box width={"100%"}>
      <Grid flexDirection={"row"} spacing={1} container>
        <Grid item xs={6}>
          <Button fullWidth variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
        </Grid>

        <Grid item xs={6}>
          <Button
            fullWidth
            variant="contained"
            onClick={handleLogout}
            sx={{ backgroundColor: "#2B7FFF" }}
          >
            Ok
          </Button>
        </Grid>
      </Grid>
    </Box>
  );

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={"xs"}
      customWidth="434px"
      smallContent={true}
      handleClose={handleClose}
      renderActions={renderActions}
      renderContent={renderContent}
      renderTitle={renderTitle}
      // showCloseButton
      // filter={false}
    />
  );
}
